var map = {
	"./TranspacificWW.svg": "b55b",
	"./artesia.svg": "0c20",
	"./bcaa.svg": "df85",
	"./brands.svg": "4f77",
	"./camdenwalk.svg": "d4be",
	"./cathaybank.svg": "a845",
	"./cbre.svg": "4d54",
	"./colliers.svg": "3c9f",
	"./craft.svg": "4e39",
	"./dava.svg": "1f49",
	"./directionlegal.svg": "99d6",
	"./directionlegal2.svg": "6572",
	"./firstmanchester.svg": "a02d",
	"./justwest.svg": "964a",
	"./kentwood.svg": "c5bd",
	"./modus.svg": "2d2c",
	"./mosaic.svg": "7db3",
	"./onni.svg": "6adc",
	"./polygon.svg": "1afd",
	"./rennie.svg": "5ffc",
	"./rodgerscreek.svg": "de0a",
	"./sprottshaw.svg": "19e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3415";